// src/api.js
import axios from "axios";

/**
 * Save one dog's activity to the backend.
 * DataModal calls this with a single object:
 * {
 *   id, activities, firstName, lastName, activityType
 * }
 */
export async function sendToBackend(payload) {
  // POST to your Vercel serverless function (same origin)
  const res = await axios.post("/api/save", payload, {
    headers: { "Content-Type": "application/json" },
  });
  // some routes may return empty body; tolerate that
  return res.data ?? {};
}

/** Fetch dogs for the UI */
export async function fetchDogs() {
  const res = await axios.get("/api/dogs");
  return res.data;
}

/** Delete by id (if/when you call it) */
export async function deleteById(id) {
  const res = await axios.post("/api/delete", { id }, {
    headers: { "Content-Type": "application/json" },
  });
  return res.data ?? {};
}
